import { useEffect, useRef, useState } from 'react'
import { api } from '../net/apiClient.js'

/**
 * Der Anmeldelink aus der E-Mail.
 *
 * Diese Seite hat genau eine Aufgabe: den Token einlösen und die Person
 * weiterschicken. Sie zeigt kein Formular, weil es nichts einzugeben gibt –
 * der Nachweis steht in der Adresszeile.
 *
 * Nach dem Einlösen geht es über einen vollständigen Seitenwechsel weiter und
 * nicht über einen Zustandswechsel in React. Der Grund: die Sitzung liegt jetzt
 * in einem Cookie, und der Rest der Anwendung baut sich aus `/me` auf. Ein
 * Neuladen ist hier der kürzeste Weg zum richtigen Zustand – auch zum
 * Zwischenschritt für den zweiten Faktor, den `/me` von sich aus meldet.
 *
 * **Der zweite Faktor wird nicht übersprungen.** Hat die Person einen
 * eingerichtet, entsteht serverseitig eine unfertige Sitzung, und die
 * Anwendung fragt nach dem Neuladen nach dem Code. Diese Seite muss dafür
 * nichts tun – und darf es auch nicht: eine zweite Stelle, die über den
 * zweiten Faktor entscheidet, ist eine Stelle, an der er irgendwann fehlt.
 */
export function Anmeldelink({
  token,
  aufLogin
}: {
  token: string
  aufLogin: () => void
}): JSX.Element {
  const [fehler, setFehler] = useState<string | null>(null)
  /*
    Der Token wird genau einmal eingelöst.

    Ohne diese Sperre löst React im Entwicklungsmodus den Effekt zweimal aus
    (StrictMode). Der zweite Aufruf träfe einen bereits verbrauchten Token,
    und die Seite zeigte einen Fehler, obwohl die Anmeldung geklappt hat.
  */
  const gestartet = useRef(false)

  useEffect(() => {
    if (gestartet.current) return
    gestartet.current = true

    if (!token) {
      setFehler('Dieser Link ist unvollständig. Bitte einen neuen anfordern.')
      return
    }

    api
      .anmeldelinkEinloesen(token)
      .then(() => {
        window.location.replace('/app')
      })
      .catch((e: unknown) => {
        setFehler(
          e instanceof Error
            ? e.message
            : 'Dieser Link gilt nicht mehr. Bitte einen neuen anfordern.'
        )
      })
  }, [token])

  return (
    <div className="rp-public rp-glasseite">
      <main className="rp-pg-kapitel" style={{ maxWidth: 520, margin: '0 auto', padding: '15vh 24px' }}>
        <h1>Anmeldung</h1>
        {fehler ? (
          <>
            <p role="alert">{fehler}</p>
            <button type="button" className="rp-pg-knopf rp-pg-knopf-hell" onClick={aufLogin}>
              Zur Anmeldung
            </button>
          </>
        ) : (
          <p>Einen Moment – der Link wird geprüft.</p>
        )}
      </main>
    </div>
  )
}
